<template>
    <div class="top-bar-content">
        <div class="left-logo"></div>
        <div class="center-logo"></div>
        <div class="top-bar-content-right">
            <div class="instruction" @click="dialogFormVisible=true">系统说明</div>
            <el-dropdown class="user-manage" split-button type="primary" @command="handleCommand" v-if="isChild==0" @click="handleClick">
                {{nick}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">账户中心</el-dropdown-item>
                    <el-dropdown-item command="2">退出登录</el-dropdown-item>
                    <!--<component :is="item.component" :text="item.text" v-for="item in items"></component>-->
                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="user-manage" split-button type="primary" @command="handleCommand" v-else-if="isChild==1" @click="childClick">
                {{nick}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="3">账户中心</el-dropdown-item>
                    <el-dropdown-item command="2">退出登录</el-dropdown-item>
                    <!--<component :is="item.component" :text="item.text" v-for="item in items"></component>-->
                </el-dropdown-menu>
            </el-dropdown>
        </div>
            <el-dialog class="instruction-dialog" title="系统说明" width="6rem" :visible.sync="dialogFormVisible">
                <div>
                    <h3>蜂电网络智能设备管理系统使用说明 </h3>

                    <h4>一、登陆</h4>
                    <p>
                        登陆后，有效期为一小时；超过有效期后，需要重新登陆。
                    </p>
                    <h4>二、首页信息</h4>
                    <p>
                        房源数据展示房源信息，其中异常表示建立了房源但是没有绑定设备。<br/>
                        电表数据展示用电及各状态设备数目，其中异常设备是指设备在线但65分钟无数据上报。<br/>
                    </p>
                    <h4>三、房源管理</h4>
                    <p>
                        房源管理页面是管理系统的主要页面，用户可以在该页面中完成大部分操作。<br/>
                        左侧展示房源树状图，房源树每一级均可点击，并在页面中部展示所选区域的房源信息，在页面右侧展示该区域的统计信息。点击“授权账号房源管理”展示用户创建的所有授权帐号，点击账号展开授权房源树状图。<br/>
                        页面中部展示所选区域每套房源信息。每套房源中第一块为总体信息，其后依次展示各房间信息。房间信息框下方的四个图标分别为：通断电控制按钮、线下充值按钮、房间离在线状态、用电记录展示按钮，点击各按钮可进行下一步操作。<br/>
                        页面右侧根据用户点击，展示不同的信息。当用户点击选中树状图某个区域时，右侧展示区域的统计信息。当用户点击选中某套房时，右侧按“电表”、“门锁”、“水表”窗口展示公共设备的信息。当用户点击选中某房间时，右侧窗口按“房间”、“电表”分别展示；其中房间窗口中可以修改房间名称，窗口下方四个图标分别为：入住/退房按钮、授权按钮、入住记录按钮、操作记录按钮。<br/>
                    </p>
                    <h4>四、账户管理</h4>
                    <p>
                        该页面用于展示、添加、修改、删除用户名下的授权账号。
                    </p>
                    <h4>五、异常管理</h4>
                    <p>
                        该页面用于各异常情况的信息展示、表格导出。<br/>
                        注：当用户管理的设备数目较多时，该页面的加载速度会下降。
                    </p>
                    <h4>六、报表统计</h4>
                    <p>
                        该页面用于一些统计信息的展示、表格导出。
                    </p>
                    <h4>七、资金管理</h4>
                    <p>
                        该页面用于租客充值数据及用户提现数据的展示、表格导出。
                    </p>
                    <h4>八、用户中心</h4>
                    <p>
                        点击管理页面右上角的向下箭头图标，出现“用户中心”和“退出登陆”按钮，选中“用户中心”按钮后，进入用户中心界面。用户中心界面分为“我的钱包”，“个人信息”，“参数设置”，“帮助文档”四个页面。<br/>
                        “我的钱包”页面用于展示用户的账户余额、提现账户信息、充值/提现记录。<br/>
                        “个人信息”页面用于展示/修改用户的一些注册信息。<br/>
                        “参数设置”页面用于展示/修改房源管理中的全局配置。<br/>
                        点击左上角“蜂电科技”或右上角用户账号，可以退出用户中心界面，回到管理界面。<br/>
                        注：该界面中提现功能、所有修改功能未开放，如有需要请使用APP端。<br/>
                    </p>
                    <h4>九、退出登陆</h4>
                    <p>
                        点击管理页面右上角的向下箭头图标，出现“用户中心”和“退出登陆”按钮，选中“退出登陆”按钮，退出系统。
                    </p>
                    <h4>十、授权账号</h4>
                    <p>
                        授权账号是受限账号，在管理界面中，仅展示房源管理、异常管理页面；在用户中心界面中，仅展示个人信息和帮助文档页面。
                    </p>

                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "TopBar",
        data() {
            return {
                userid: window.localStorage.userid,
                isChild: window.localStorage.isChild,
                nick: window.localStorage.nick,
                dialogFormVisible:false,
            }
        },
        methods: {
            handleCommand(command) {
                if (command == "1") {
                    this.$router.push('./purse');
                } else if (command == "2") {
                    window.localStorage.token = '';
                    window.localStorage.uid = '';
                    this.$router.push('./')
                }else if(command == "3"){
                    this.$router.push('./personal')
                }
            },
            handleClick(){
                this.$router.push('./home');
            },
            childClick() {
                this.$router.push('./house');
            }

        }
    }
</script>

<style scoped>
    .top-bar-content {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        z-index:5000;
    }
    .center-logo{
        margin-left:15%;
        font-size: 0.28rem;
        /*width:50%;*/
        height:100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }
    .top-bar-content-right {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 4rem;
        /*float: right;*/
        height: 100%;
    }
    .top-bar-content-right .user-manage {
        font-size: 0.1vw;
        margin:0 0.15rem 0 1vw;
    }
    .instruction:hover{
        color:#409EFF;
        cursor:pointer;
        text-decoration:underline;
    }
    .el-dialog__body {
        padding: 0px 20px;
    }
    .changeAccount {
        margin-right: 1vw;
    }
</style>